import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {EnergieEnum} from '../../pages/rt2012/suivi-des-consommations/enums/EnergieEnum';
import {TypeReleveConsoEnum} from '../../pages/rt2012/edit-releve/enums/TypeReleveConsoEnum';
import {Entity} from '../entity';

@inheritSerialization(Entity)
export class AbstractReleve extends Entity{

  @deserializeAs(Date)
  date: Date = null;

  @deserializeAs(EnergieEnum)
  energie: EnergieEnum;

  @deserialize
  valeur: number;

  @deserializeAs(TypeReleveConsoEnum, 'type_releve')
  typeReleve: TypeReleveConsoEnum;
}
